const SET_ASSESSMENT_YEAR_INDICATOR = 'SET_ASSESSMENT_YEAR_INDICATOR'
const RESET_ASSESSMENT_INDICATOR = 'RESET_ASSESSMENT_INDICATOR'
const CHANGE_SELECTED_OPTION = 'CHANGE_SELECTED_OPTION'

export const setIndicator = (options) => dispatch => {
    localStorage.setItem('schoolYearIndicator', JSON.stringify(options)) 
    dispatch( {
      type: SET_ASSESSMENT_YEAR_INDICATOR,
      options
    })
  }

export const changeSelectedOption = (option) => dispatch => {
  dispatch({
    type: CHANGE_SELECTED_OPTION,
    option
  })
}

export const clearIndicator = () => {
    return {
      type: RESET_ASSESSMENT_INDICATOR,
    }
  }
  
  const options = JSON.parse(localStorage.getItem('schoolYearIndicator'))
  const initialState = {
    selectOptions: options ? options.selectOptions : [], 
    defaultValue: options ? options.defaultValue : {},
    selectedOption: options ? options.selectedOption : {}
}

export function assessmentIndicator (state = initialState, action) {
  switch (action.type) {
    case SET_ASSESSMENT_YEAR_INDICATOR :
      return {
        ...state,
        ...action.options
      }
    case CHANGE_SELECTED_OPTION :   
      return {
        ...state,
        selectedOption: action.option

      }
    case RESET_ASSESSMENT_INDICATOR : 
    localStorage.removeItem('schoolYearIndicator')
      return {
        selectOptions: [], 
        defaultValue: {},
        selectedOption: {}
      }  
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/assessmentIndicator.js